import moment from '@/assets/setups/moment'

/** parse a json date into a pretty format
@date { string } - json date
@initialFormat {String} - date initial format, so moment knows what format transforms into another
@returns { string } - parsed date example: 22 Jan 2022
*/
export const getDate = (date, initialFormat) => {
    if (date === '' || date === null || date === undefined) return null
    if (initialFormat) return moment(date, initialFormat).format('D MMM YYYY')
	return `${moment(date).format('D')} ${moment(date).format('MMM').charAt(0).toUpperCase()}${moment(date).format('MMM').slice(1)} ${moment(date).format('YYYY')}`
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 22 Jan 2022, 15:30
*/
export const getDateWithTime = date => {
    return moment(date).format('D MMM YYYY, HH:mm')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 05/2022
*/
export const getMonthYear = date => {
    return moment(date).format('MM/YYYY')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 2022
*/
export const getYear = date => {
    return moment(date).format('YYYY')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example 15h30
*/
export const getTime = date => {
    return moment(date).format('HH[:]mm')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example 15h30:00
*/
export const getTimeWithSeconds = date => {
	return moment(date).format('HH[:]mm[:]ss')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 0000-00-00T00:00:00.000Z
*/
export const createJSONDateNoTimezone = date => {
	return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON()
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 0000-00-00T23:59:59.999Z
*/
export const createJSONDateEndDay = date => {
    if (date === '' || date === null || date.length === 0) return null
	return `${new Date(date).toJSON().split('T')[0]}T23:59:59.999Z`
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 0000-00-00T00:00:00.000Z
*/
export const createJSONDateStartDay = date => {
    if (date === '' || date === null || date.length === 0) return null
	return `${new Date(date).toJSON().split('T')[0]}T00:00:00.000Z`
}

/** parse seconds into a pretty format
@time { string } - seconds
@returns { string } - returns minutes:seconds
*/
export const parseTimer = time => {
    let hours = 0
	let minutes = Math.floor(time / 60)
	const seconds = Math.floor(time - minutes * 60)
    /* If more than 60min we will apply hours */
    if (minutes > 60) {
        hours = Math.floor(minutes / 60)
        minutes = Math.floor(minutes - hours * 60)
    }

    /* Creating minutes text */
	let minutesText = minutes === 0 ? '00' : `${minutes}`
    if (hours && minutes < 10 && minutes !== 0) minutesText = `0${minutes}`
    /* Creating seconds text */
	let secondsText = seconds === 0 ? '00' : `${seconds}`
	if (secondsText < 10) secondsText = `0${seconds}`

	return hours ? `${hours}:${minutesText}:${secondsText}` : `${minutesText}:${secondsText}`
}
